module.exports = __webpack_public_path__ + "img/icon_01.f9b7ab6.png";